// src/pages/ManageAccounts.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useStore } from '../store';
import { getPlatform } from '../utils/platforms';

export default function ManageAccounts() {
  const navigate = useNavigate();
  const { accounts, accountsLoading, fetchAccounts, reconnectAccount, deleteAccount, user } = useStore();
  const canManage = ['owner', 'admin'].includes(user?.org_role);
  const [search, setSearch] = useState('');

  useEffect(() => { fetchAccounts(); }, []);

  const filtered = accounts.filter(a => a.account_name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="page-header">
        <div>
          <span className="page-title">Accounts</span>
          <span style={{ fontSize: 11, color: '#8892a4', marginLeft: 14 }}>1 — {filtered.length} of {accounts.length}</span>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="filter-pill">❓</button>
          {canManage && <button className="btn btn-primary" onClick={() => navigate('/accounts/connect')}>+ Connect Account</button>}
        </div>
      </div>
      <div className="toolbar">
        <input type="checkbox" style={{ accentColor: '#0f766e' }} />
        <div className="search-box"><span style={{ color: '#aaa' }}>🔍</span><input placeholder="Search an account" value={search} onChange={e => setSearch(e.target.value)} /></div>
        <button className="filter-pill">⚡ Filter Accounts</button>
      </div>
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {accountsLoading ? <div className="loading-center"><div className="spinner" /></div> :
          filtered.length === 0 ? (
            <div className="empty-state">
              <span style={{ fontSize: 40 }}>🔌</span>
              <h3>No accounts connected</h3>
              <p>Connect your social media accounts to start scheduling posts</p>
              {canManage
                ? <button className="btn btn-primary" onClick={() => navigate('/accounts/connect')}>Connect Account</button>
                : <p>Ask an owner or admin of your organization to connect one.</p>}
            </div>
          ) : (
            <table className="data-table">
              <thead><tr><th><input type="checkbox" style={{ accentColor: '#0f766e' }}/></th><th>ID ↑</th><th>Account Name ↑</th><th>Platform</th><th>Last Connected By</th><th>Status</th><th></th></tr></thead>
              <tbody>
                {filtered.map(a => {
                  const p = getPlatform(a.platform);
                  return (
                    <tr key={a.id}>
                      <td><input type="checkbox" style={{ accentColor: '#0f766e' }}/></td>
                      <td style={{ color: '#aaa', fontSize: 11 }}>{a.id.slice(0, 8)}</td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                          <div className="platform-icon" style={{ background: p.bg, color: p.color, width: 20, height: 20 }}>{p.icon}</div>
                          <span style={{ color: a.is_connected ? '#0f766e' : '#e55b2d', fontWeight: 500, cursor: 'pointer' }}>{a.account_name}</span>
                        </div>
                      </td>
                      <td style={{ color: '#555' }}>{p.name}</td>
                      <td style={{ color: '#555' }}>{a.last_connected_by || '—'}</td>
                      <td>
                        {a.is_connected
                          ? <span style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#059669', fontSize: 11, fontWeight: 500 }}>✅ Active</span>
                          : <span style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#e55b2d', fontSize: 11, fontWeight: 500 }}>⚠ Needs reconnect</span>}
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 6 }}>
                          {canManage && <>
                          <button className="reconnect-btn" onClick={async () => { await reconnectAccount(a.id); toast.success(`${a.account_name} reconnected!`); }}>↺ Reconnect</button>
                          <button className="btn btn-danger" style={{ padding: '4px 8px', fontSize: 11 }} onClick={async () => { if (window.confirm('Remove this account?')) { await deleteAccount(a.id); toast.success('Account removed'); } }}>🗑</button>
                          </>}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )
        }
      </div>
    </div>
  );
}
